// extracted by mini-css-extract-plugin
export var black = "_3n-6";
export var brand = "_3n-1";
export var ddefault = "_3n-0";
export var error = "_3n-3";
export var gray = "_3n-2";
export var highContrast = "_3n-8";
export var outline = "_3n-7";
export var success = "_3n-5";
export var warning = "_3n-4";